<template>
  <div>
    <div class="accordion-item">
      <span class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>What does Phairify do?</strong><br>
            Phairify provides a dynamic digital job marketplace for physicians and employers to directly connect on desirable job opportunities. Phairify activates and delivers physician job candidates not otherwise reachable in the job market, and our matching software lets you direct your job opportunities precisely to those candidates who have already expressed interest in the specific attributes of the job you are promoting. Phairify = more active candidates + precise targeting of your job opportunities.
          </span>
        </div>
      </span>
    </div>
    <div class="accordion-item">
      <span href="#" class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>Is Phairify a job board?</strong><br>
            No. Unlike job boards which post static job descriptions with the hopes of attracting an interested candidate from a limited and stagnant pool, Phairify connects employers and recruiters directly to candidates who have already expressed interest in the specific attributes of the job you are promoting and who are new entrants to the marketplace because of Phairify.           </span>
        </div>
      </span>
    </div>
    <div class="accordion-item">
      <span href="#" class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>How do I identify candidates interested in my job opportunity?</strong><br>
            Phairify does it for you, for free! All physician candidates in Phairify’s marketplace define and present the exact terms (location, practice type, compensation, etc.) of their desired job opportunities. Employers and recruiters then enter the terms of their job opportunities and Phairify identifies candidates who desire opportunities which match yours. If you are satisfied with the number of matching candidates, you pay us to immediately alert those interested candidates to that desired available opportunity. If you are not satisfied you can manipulate the terms of your search (e.g., 10% higher compensation) and see how the market views those changes.         </span>
        </div>
      </span>
    </div>
    <div class="accordion-item">
      <span href="#" class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>How does Phairify’s pricing work?</strong><br>
            Phairify’s initial offering connects a single employer-defined job opportunity to all matching candidates for a period of 90 days. We offer bundled pricing if you want to use Phairify’s platform for multiple job opportunities.
          </span>
        </div>
      </span>
    </div>
    <div class="accordion-item">
      <span href="#" class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>Does the price change as Phairify connects me to more candidates?</strong><br>
            No, Phairify’s price for connecting customer job opportunities to candidates is the same, whether the opportunity is connected to 1 candidate or 100 candidates.          
          </span>
        </div>
      </span>
    </div>
    <div class="accordion-item">
      <span href="#" class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>It’s hard to know if the job opportunities I am offering are market-relevant – can Phairify help with that?</strong><br>
            Yes! We believe a great deal of inefficiency in the job market results directly from information asymmetry – that is, because physicians and employers often have different understandings of clinicians’ specialty-specific market value, it’s difficult for candidates and employers to even start a discussion about compensation and other job terms. Phairify offers candidates and employers real-time, filterable, specialty-specific market data (productivity, compensation, and practice information) which we call Inform, to help the parties understand the true value for a specific role (based on the market, the practice type, etc.) and allow them to get to ‘yes’ more quickly. The days where only one side knows the real market value for a car or flight or house are over, and we think it should be that way in the physician professional services market.        
          </span>
        </div>
      </span>
    </div>
    <div class="accordion-item">
      <span href="#" class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>What happens after I connect my job opportunity to interested candidates?</strong><br>
            Once you elect to pay to connect a job opportunity to Phairify’s interested candidates, Phairify immediately alerts those candidates they have a desired match. Candidates then can contact you directly to discuss the job opportunity or contact you through Phairify’s anonymous communicator if they have further questions about the details of the job opportunity.       
          </span>
        </div>
      </span>
    </div>
    <div class="accordion-item">
      <span href="#" class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>Can I refine my job opportunity after my initial design and payment?</strong><br>
            Yes, you may update or revise the terms of your job opportunity as many times as you want during the 90-day period. The only job opportunity terms you may not revise after the initial connection are Specialty, Location, and Permanent / Locums.           
          </span>
        </div>
      </span>
    </div>
    <div class="accordion-item">
      <span href="#" class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>What if new candidates match my job opportunity terms after I initiate my connection and 90-day term?</strong><br>
            Once your job opportunity is available Phairify will connect your opportunity to any matching candidate job profile even if that desired job profile was created after the date you initiated the offering. Our goal is to maximize meaningful connections between candidates and opportunities.          
          </span>
        </div>
      </span>
    </div>
    <div class="accordion-item">
      <span href="#" class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>When will I know the identity of the physicians behind each anonymous profile?</strong><br>
            Physicians’ anonymous job market participation is what allows Phairify to give you access to an entirely new pool of job candidates – by offering a risk-free way for physicians to enter the job market and connecting them to you. Accordingly, all Phairify candidates remain anonymous until they elect to contact you about a matched job opportunity.        
          </span>
        </div>
      </span>
    </div>
    <div class="accordion-item">
      <span href="#" class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>If your candidates are anonymous, how do I know they are qualified for the role I need to fill?</strong><br>
            We validate and authenticate all Phairify candidates by screening and confirming their credentials through their memberships with national medical and surgical specialty societies.        
          </span>
        </div>
      </span>
    </div>
    <div class="accordion-item">
      <span href="#" class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>Does Phairify collect a placement or success fee if I place or hire a connected candidate?</strong><br>
            No, not with this initial Phairify offering. Our goal is to illuminate the physician job market and reduce the time and cost spent connecting the right candidates to the right opportunities. We charge our employer and recruiter customers for access to our efficient marketplace with a new pool of candidates. Once we’ve introduced the interested parties, we leave closing the deal – and any fees associated with those efforts – to you.        
          </span>
        </div>
      </span>
    </div>
    <div class="accordion-item">
      <span href="#" class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>Who sees the terms of the job opportunity I design on Phairify?</strong><br>
            Phairify lets you search discretely for matching qualified candidates, eliminating the risk of losing candidates to the competition. You no longer are confronted by having to choose the lesser evil of disclosing sensitive compensation details in a job ad or describing a role’s compensation as “generous” or “competitive.”       
          </span>
        </div>
      </span>
    </div>
    <div class="accordion-item">
      <span href="#" class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>Can I create and connect multiple job opportunities?</strong><br>
            Of course. Phairify organizes its physician candidate supply by specialty and we are constantly engaging and bringing new specialties on to our platform. Window-shop our showroom to see if Phairify candidates are interested in the jobs you are looking to fill.    
          </span>
        </div>
      </span>
    </div>
    <div class="accordion-item">
      <span href="#" class="flex justify-between">
        <div class="accordion_header">
          <span class="heading pt-2">
            <strong>Can I communicate with the interested candidates after I connect my job opportunity?</strong><br>
            Yes, immediately after you pay and launch your job opportunity, all matching candidates will receive a ‘match’ alert and the details of the matching job opportunity. We will alert you as candidates check on the opportunity. Interested candidates then click to learn more and we disclose the full details of the job opportunity as you have defined them. We will notify you when candidates have accessed all available job opportunity details. Candidates then may contact you directly or interact anonymously with you though our communicator tool to address and resolve any outstanding questions about the role.    
          </span>
        </div>
      </span>
    </div>
  </div>
  </template>
  
  <script>
  export default {
    name: "RecruiterAccordion",
    props: [
      'title'
    ],
  }
  </script>
  
  <style scoped lang="scss">
  @import 'sass/variables_mixins';
  
  .accordion_header {
    width: 100%;
    box-shadow: 0 0 10px 0 #c8c8c8;
    min-height: 80px;
    margin-bottom: 20px;
    padding: 20px;
    float: left;
    position: relative;
  }
  
  .accordion_content {
    padding: 20px;
  }
  
  a, a:hover {
    color: $dark-blue;
    text-decoration: none;
  }
  
  .icon-wrapper {
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    right: 20px;
  }
  
  .heading {
    float: left;
    max-width: 80%;
  }
  </style>
  
  